import React, { Component, Fragment } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from "react-js-pagination";
import { currentDate, formatDateTime } from '../../../lib/common'
import { GIAOHANG_REPORT_LIST_SUCCESS } from './constants'
import * as giaoHangReportAction from './actions'
import { storedb } from '../../../views/client/storedb'
import DisplayRecordText from "../../controls/_DisplayRecordText"
import Autocomplete from "../../controls/_Autocomplete";
class GiaoHangReport extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      item: {},
      list: [],
      status: '',
      keyword: '',
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      per_page: 20,
      page: 1,
      total_record: 0,
      listOrderUpdate: [],
      selectedAll: false,
      NhanVienGiaoHangSuggestions: [],
      customersCtl: {},
      itemNVGiaoHang: {},
      totalPaid: 0,
      totalAmount: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  handleSearchChange = (e, name) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleDateChange(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  handleSelectChange = ({ target }) => {
    this.setState({ status: target.value })
  }
  getRequestParam(isExport) {
    var requestData = {
      store_id: this.state.stores_id,
      keyword: this.state.keyword,
      status: this.state.status,
      tu_ngay: this.state.tuNgay.format('YYYY-MM-DD'),
      den_ngay: this.state.denNgay.format('YYYY-MM-DD'),
      nvGiaoHang: this.state.itemNVGiaoHang.value
    }
    if (!isExport) {
      requestData.page = this.state.page
      requestData.per_page = this.state.per_page
    }
    return requestData
  }
  fetchList = () => {
    const { giaoHangReportListRequest } = this.props
    const requestData = this.getRequestParam(false)
    return giaoHangReportListRequest(requestData);
  }
  search = () => {
    if (this.props.giaoHangReport.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  formatNhanVienGiaoHangOptions = (list) => {
    let NhanVienGiaoHangSuggestions = [];
    list.forEach(function (item) {
      let option = null;
      const label = item.MaNhanVienGiao ? `${item.MaNhanVienGiao}-${item.TenNhanVien}` : `${item.TenNhanVien}`
      option = {
        value: item.NhanVienId,
        label: label,
        ma: item.MaNhanVienGiao
      };
      NhanVienGiaoHangSuggestions.push(option);
    });
    this.setState({ NhanVienGiaoHangSuggestions });
  }
  getListNVGH(keyword, callback) {
    const { giaoHangReportListNvRequest } = this.props
    const requestData =
    {
      store_id: this.state.stores_id,
      keyword: keyword,
      page: 1,
      per_page: 20,
    }
    return giaoHangReportListNvRequest(requestData, (data) => {
      this.formatNhanVienGiaoHangOptions(data)
      if (callback) {
        callback(data)
      }
    })
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  exportXls = () => {
    const { giaoHangReportExportXlsRequest } = this.props

    const requestData = this.getRequestParam(false)
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "baocao_giaohang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    return giaoHangReportExportXlsRequest(requestData, dialogSaveFile)
  }
  onHandleSelectNVGHChange = (selectedOption) => {
    selectedOption = selectedOption || { value: 0, label: '' }
    this.setState({ itemNVGiaoHang: selectedOption })
  }
  handleClearClick = (item) => {
    this.setState({ itemNVGiaoHang: { value: 0, label: '' } })
  }
  UpdateGiaoHangItem = (item, e) => {
    e.preventDefault();
    this.props.history.push('/giaohang-edit?o=' + (item.BanId || ""));
  }
  NhanVienGiaoHangChanged = (input, callback) => {
    this.getListNVGH(input, callback);
  }
  formatNhanVienGiaoHangOptionLabel = (option) => {
    return (
      <div className="item">
        {'\u00A0'}{'\u00A0'}{option.label}
      </div>
    )
  }
  formatNhanVienGiaoHangNoOptionLabel = (input) => {
    return (
      <Fragment>
        <div><em>Không tìm thấy dữ liệu</em></div>
      </Fragment>
    )
  }
  setCustomersCtl = (e) => {
    this.setState({ customersCtl: e });
  }
  componentDidMount() {
    this.getListNVGH()
    // this.fetchList();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.giaoHangReport.type == GIAOHANG_REPORT_LIST_SUCCESS) {
      let { list, item } = nextProps.giaoHangReport;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list,
        totalAmount: item.total_amount || 0,
        totalPaid: item.total_paid || 0
      });
    }
  }
  render() {
    const {
      handleSubmit,
      giaoHangReport: {
        listRequesting,
        list
      },
    } = this.props
    const {
      NhanVienGiaoHangSuggestions
    } = this.state
    const getClassStatus = (status) => {
      switch (status) {
        case 9:
          return "text-danger"
        case 20:
          return "text-success"
        default:
          return ""
      }
    }
    const hadChecked = this.state.listOrderUpdate && this.state.listOrderUpdate.length > 0
    const startIndex = (this.state.page > 0 ? this.state.page - 1 : 0) * this.state.per_page
    return (
      <div className="animated fadeIn report">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="12" className="mb-2 pl-2 pr-2 half-right">
                  <InputGroup size="md">
                    <InputGroupAddon className="d-none d-sm-block" addonType="prepend" autoComplete="off" >Từ khóa</InputGroupAddon>
                    <Input name="keyword"
                      placeholder="Mã đơn hàng hoặc tên nhân viên kd"
                      value={this.state.keyword}
                      autoComplete="off"
                      onKeyDown={e => this.keyPress(e)}
                      onChange={e => this.handleSearchChange(e, "keyword")} />
                  </InputGroup>
                </Col>
                <Col md="2" sm="3" xs="6" className="mb-2 pl-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      name="tuNgay"
                      placeholder="Từ ngày"
                      selected={this.state.tuNgay}
                      onChange={this.handleDateChange.bind(this, "tuNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col md="2" sm="3" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      name="denNgay"
                      placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={this.handleDateChange.bind(this, "denNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col md="4" sm="6" xs="4" className="mb-2 pl-2 pr-2 half-left">
                  <InputGroup size="md">
                    <select className="form-control" onChange={(e) => this.handleSelectChange(e)} value={this.state.TrangThai}>
                      <option value="">--Trạng thái--</option>
                      <option value={0}>Chưa giao</option>
                      <option value={1}>Đang giao</option>
                      <option value={20}>Đã giao</option>
                      <option value={9}>Tạm dừng</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col md="4" sm="12" xs="8" className="mb-2 pl-2 pr-2 half-right">
                  <Autocomplete
                    name="customerSelect"
                    placeholder={"Nhân viên giao hàng"}
                    clearOnSelection={false}
                    formatOptionLabel={this.formatNhanVienGiaoHangOptionLabel}
                    formatNoOptionLabel={this.formatNhanVienGiaoHangNoOptionLabel.bind(this)}
                    handleChange={this.NhanVienGiaoHangChanged.bind(this)}
                    onSelection={this.onHandleSelectNVGHChange.bind(this)}
                    suggestions={NhanVienGiaoHangSuggestions}
                    handleClearClick={this.handleClearClick.bind(this)}
                    onRef={(ctl) => this.setCustomersCtl(ctl)}
                  />
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="w-100 mb-2 mt-2 mb-2">
            <Button size="md" color="success" className="pull-left mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
            <Button size="md" color="primary" className="pull-left mr-1" onClick={this.exportXls}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            <div className="clearfix" ></div>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" className="text-center">#</th>
                    <th scope="col" className="text-left">Ngày giao</th>
                    <th scope="col" className="text-left">Mã đơn hàng</th>
                    <th scope="col" className="text-left">Khách hàng</th>
                    <th scope="col" className="text-right">Tổng tiền</th>
                    <th scope="col" className="text-right">Đã thu</th>
                    <th scope="col" className="text-left">Người giao</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan="4">
                      <span className="font-weight-bold">Tổng cộng</span>
                    </td>
                    <td className="text-right text-success"><b>{this.state.totalAmount.toLocaleString()}₫</b></td>
                    <td className="text-right text-success"><b>{this.state.totalPaid.toLocaleString()}₫</b></td>
                    <td className="text-right"></td>
                  </tr>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{startIndex + (idx + 1)}</td>
                        <td className="text-left">{formatDateTime(res.NgayGiao, "DD/MM/YYYY")}</td>
                        <td className="text-left"><a href="#" onClick={this.UpdateGiaoHangItem.bind(this, res)}>{res.MaDonHang}</a></td>
                        <td className="text-left">{res.TenKhachHang}-{res.MaKhachHang}</td>
                        <td className="text-right font-weight-bold">{parseFloat(res.TongTien || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right font-weight-bold text-danger">{parseFloat(res.SoTienThu || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-left">{res.TenNguoiGiao}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  giaoHangReport: state.giaoHangReport,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  giaoHangReportListRequest: giaoHangReportAction.giaoHangReportListRequest,
  giaoHangReportListNvRequest: giaoHangReportAction.giaoHangReportListNvRequest,
  giaoHangReportExportXlsRequest: giaoHangReportAction.giaoHangReportExportXlsRequest,
})(GiaoHangReport)
const formed = reduxForm({
  form: 'giaoHangReport',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/Reports/GiaoHangReport/GiaoHangReport.js